import React, { useState } from 'react';
import './ListInput.css';

interface ListInputProps {
  label: string;
  values: string[];
  onChange: (updated: string[]) => void;
}

const ListInput: React.FC<ListInputProps> = ({ label, values, onChange }) => {
  const [input, setInput] = useState('');

  const handleAdd = () => {
    const trimmed = input.trim();
    if (trimmed && !values.includes(trimmed)) {
      onChange([...values, trimmed]);
      setInput('');
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAdd();
    }
  };

  const removeItem = (item: string) => {
    onChange(values.filter(v => v !== item));
  };

  return (
    <div className="list-input-group">
      <label>{label}</label>
      <div className="list-input-wrapper">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Type and press Enter"
        />
        <button type="button" onClick={handleAdd}>Add</button>
      </div>
      <div className="list-chips">
        {values.map((val, i) => (
          <span className="chip" key={i}>
            {val}
            <button type="button" onClick={() => removeItem(val)}>×</button>
          </span>
        ))}
      </div>
    </div>
  );
};

export default ListInput;
